import { Component, OnInit } from "@angular/core";
import { FirmService } from "../firm.service";
import { AuthService } from "@app/core/services";

@Component({
  selector: "sa-firm-selector",
  templateUrl: "./firm-selector.component.html"
})
export class FirmSelectorComponent implements OnInit {
  public firms: Array<any>;
  public currentFirm: any;

  constructor(
    private firmService: FirmService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    if (this.isAuthenticated) {
      this.firmService.getFirmsForSelect().subscribe(data => {
        this.firms = data;
        this.currentFirm = sessionStorage.getItem("firmTitle");
      });
    }
  }

  get isAuthenticated() {
    return this.authService.loggedIn();
  }

  selectFirm(firm) {
    if (
      confirm(
        "Firma değiştirmek istediğinize emin misiniz? Bundan sonraki işlemleriniz seçtiğiniz firmaya göre yapılacaktır!"
      )
    ) {
      sessionStorage.setItem("firmTitle", firm.sTitle);
      this.currentFirm = sessionStorage.getItem("firmTitle");
      this.firmService.selectFirm(firm.id);
    }
  }
}